import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormModel } from '../../form-json.types';
import { FormCoreModule } from '../form-core.module';

@Injectable({
  providedIn: FormCoreModule
})
export class LoadFormModelService {

  constructor(private http: HttpClient) { }

  load() {
    return this.http.get<FormModel>('/assets/form.json')
  }
}